import ky from 'ky';
import { DEFAULT_API_OPTIONS } from '../config/ky';

export async function getWorks() {
  const res = await ky.get('works?limit=100', DEFAULT_API_OPTIONS);
  const works = await res.json();
  if (!works) throw Error('API error');
  return works;
}
